// Import just what we need from Bootstrap 5

// eslint-disable-next-line no-unused-vars
import { Button, Dropdown, Modal } from 'bootstrap';
